<template>
  <div class="chart-common-options-setting-1">
    <!-- 位置尺寸旋转 -->
    <div class="content-group-default">
      <div class="setting-item">
        <div class="content">
          <el-collapse v-model="activeNames">
            <!-- 背景 设置 -->
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
                title="背景"
                name="1">
              <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
              >
                <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" :options="options" />
              </div>
            </el-collapse-item>
            <!-- 边框 设置 -->
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
                title="边框"
                name="2">
              <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
              >
                <div class="setting-item">
                  <div class="content-item verticallyCenter mb8">
                    <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                  </div>
                  <cx-border
                      v-if="showBorder"
                      :borderWidth.sync="borderWidth"
                      :borderStyle.sync="borderStyle"
                      :borderColor.sync="borderColor"
                      :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
            </el-collapse-item>
            <!-- 边距设置 -->
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
                title="边距"
                name="3"
                v-if="!noPadding"
            >
              <div
                  class="setting-item setting-item-grid"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
              >
                <cx-padding
                    :paddingTypeFlag.sync="paddingTypeFlag"
                    :padding.sync="padding"
                    :paddingTop.sync="paddingTop"
                    :paddingRight.sync="paddingRight"
                    :paddingBottom.sync="paddingBottom"
                    :paddingLeft.sync="paddingLeft"
                />
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "chart-common-options-setting-1",
  components: {

  },
  props: {
    ids: null,
    options: Object,
    initCollapse: {
      type: Boolean | Array,
      default: true
    }
  },
  data() {
    return {
      baseCollapse: ["1", "2"],
      activeNames: [],
      allCollapseNames: [],
      collapseActiveNames: [],

    }
  },

  computed: {
    noPadding() {
      //  不加边距：地图、雷达、3d地图 /有坐标轴的柱状，折线，
      let noP = false, typeN = ["cxRadar","cxRealMap", "cxMap3D"]
      if(typeN.indexOf(this.options.innerElement) !== -1 || this.hasProperty(this.options, 'chartOption.grid')){
        noP = true
      }
      return noP
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle || "solid"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor || "transparent"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
              ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
              this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
  },
  methods: {

  },
  created() {

  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  }
}
</script>

<style scoped>

</style>
